export type AnalyticsConsent = "accepted" | "rejected" | "pending";
export const CONSENT_EVENT = "farbin:analytics-consent";
export function consentFromCookie(cookie: string): AnalyticsConsent {
  const value = cookie.match(/(?:^|;\s*)farbin_analytics=(on|off)(?:;|$)/)?.[1];
  return value === "on" ? "accepted" : value === "off" ? "rejected" : "pending";
}
// Collection is enabled by default. Retain explicit opt-outs from older clients.
export function analyticsConsent(): AnalyticsConsent {
  if (typeof document === "undefined") return "pending";
  if (consentFromCookie(document.cookie) === "rejected") return "rejected";
  try {
    if (localStorage.getItem("farbin.analytics.disabled") === "1")
      return "rejected";
  } catch {
    /* Storage is optional. */
  }
  return "accepted";
}
export function analyticsAllowed() {
  return (
    typeof navigator !== "undefined" &&
    typeof document !== "undefined" &&
    navigator.doNotTrack !== "1" &&
    !(navigator as Navigator & { globalPrivacyControl?: boolean })
      .globalPrivacyControl &&
    analyticsConsent() !== "rejected"
  );
}
// Restore a legacy opt-out so client and server apply the same rule.
export function synchronizeAnalyticsConsent() {
  if (
    typeof document === "undefined" ||
    consentFromCookie(document.cookie) !== "pending"
  )
    return;
  if (analyticsConsent() === "rejected") writeOptOutCookie();
}

let noticeDismissed = false;
export function analyticsNoticeSeen() {
  if (noticeDismissed) return true;
  if (
    typeof document !== "undefined" &&
    /(?:^|;\s*)farbin_analytics_notice=1(?:;|$)/.test(document.cookie)
  )
    return true;
  try {
    return localStorage.getItem("farbin.analytics.notice") === "1";
  } catch {
    return false;
  }
}
export function dismissAnalyticsNotice() {
  noticeDismissed = true;
  try {
    localStorage.setItem("farbin.analytics.notice", "1");
  } catch {
    /* Optional. */
  }
  try {
    document.cookie = `farbin_analytics_notice=1; Path=/; SameSite=Lax; Max-Age=31536000${location.protocol === "https:" ? "; Secure" : ""}`;
  } catch {
    /* Optional. */
  }
  window.dispatchEvent(new Event(CONSENT_EVENT));
}
function writeOptOutCookie() {
  try {
    document.cookie = `farbin_analytics=off; Path=/; SameSite=Lax; Max-Age=31536000${location.protocol === "https:" ? "; Secure" : ""}`;
  } catch {
    /* A legacy opt-out cookie could not be written. */
  }
}
